// Gère les onglets avec deux modes :
// - Mode bloc : affiche le contenu des blocs dans un panel
// - Mode section : masque/affiche des sections selon leur ID (via data-section-id)
class TabsContainer extends HTMLElement {
  constructor() {
    super();
    this.tabs = null;
    this.panel = null;
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-ref="tab"]');
    this.panel = this.querySelector('[data-ref="tabs-panel"]');

    const hasSectionTabs = Array.from(this.tabs).some(tab => tab.dataset.sectionId);
    if (hasSectionTabs) {
      this.#hideAllSections();
    }

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.#resetTabs();
        this.#selectTab(tab);
      });
    });

    if (this.tabs.length > 0) {
      this.#selectTab(this.tabs[0]);
    }
  }

  #selectTab(tab) {
    const sectionId = tab.dataset.sectionId;

    if (sectionId) {
      this.#showSection(sectionId);
    } else {
      const tab_content = tab.querySelector('template')?.content?.querySelector('[data-ref="tab-content"]');
      if (tab_content && this.panel) {
        this.panel.innerHTML = tab_content.innerHTML;
      }
    }

    tab.classList.add('active');
  }

  #getSectionIds() {
    return Array.from(this.tabs)
      .map(tab => tab.dataset.sectionId)
      .filter(id => id);
  }

  #hideAllSections() {
    const sectionIds = this.#getSectionIds();
    sectionIds.forEach((id) => {
      const section = document.getElementById(id);
      if (section) {
        section.style.display = 'none';
      }
    });
  }

  #showSection(sectionId) {
    this.#hideAllSections();
    const targetSection = document.getElementById(sectionId);
    if (targetSection) {
      targetSection.style.display = '';
    }
  }

  #resetTabs() {
    this.tabs.forEach((tab) => {
      tab.classList.remove('active');
    });
    
    if (this.panel) {
      this.panel.innerHTML = '';
    }
  }
}

if (!customElements.get('tabs-container')) {
  customElements.define('tabs-container', TabsContainer);
}
